<template>
  <div class="sui-form-page">
    <div class="form-left">
      <sui-form
        ref="form"
        :model="model"
        :label-width="labelWidth"
        :item-width="calcItemWidth"
        :items="items"
        :test-id="$attrs['test-id']"
        :is-test="$attrs['is-test']"
        :allow-test-components="$attrs['allow-test-components']"
        :test-suffix="$attrs['test-suffix']"
        :btns="formBtns"
        btns-inline
        v-bind="$attrs"
      >
        <template v-for="slot in Object.keys($scopedSlots)" #[slot]="scope"><slot :name="slot" v-bind="scope"></slot></template>
      </sui-form>
      <sui-form :model="model" :items="_selectedItems" :field-arr="_selectedFieldArr" />
    </div>
    <div v-if="!btnsInline" class="form-right">
      <sui-button-group class="search-btn-group" :btns="searchBtns"></sui-button-group>
    </div>
  </div>
</template>
<script>
import { each, difference } from 'lodash-es'
export default {
  name: 'SuiFormPage',
  inheritAttrs: false,
  provide() {
    return {
      SuiFormPage: this
    }
  },
  props: {
    // 查询formmodel
    model: {
      type: Object,
      required: true
    },
    // 查询项
    items: {
      type: Array,
      required: true
    },
    // 查询项，label宽度
    labelWidth: {
      type: Number,
      default: 85
    },
    // 查询项宽度
    itemWidth: {
      type: Number,
      default: null
    },
    // 重置数量，超过这个数字出现重置按钮
    resetNum: {
      type: Number,
      default: 4
    },
    // 隐藏查询项，超过这个数字，隐藏查询项
    hideNum: {
      type: Number,
      default: 8
    },
    // 查询块，其他按钮
    // 可以通过传递按钮来覆盖默认的查询按钮，重置按钮的属性。
    btns: {
      type: Array,
      default: () => []
    },
    // 按钮是否混合在form中
    btnsInline: {
      type: Boolean
    },
    // 是否展示导出
    showExport: {
      type: Boolean
    },
    // 是否开启回车搜索
    enableEnterSearch: {
      type: Boolean,
      default: false
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      moreValue: [],
      showMoreBtnText: '$t[sui.form.more]',
      hasHideItem: true,
      renderVisibleItemsProps: []
    }
  },
  computed: {
    elMode() {
      return (this.$ELEMENT || {}).$mode || 'easy'
    },
    showMore() {
      return this.items.length > this.hideNum
    },
    calcItemWidth() {
      if (this.itemWidth) {
        return this.itemWidth
      }
      const labelWidth = this.labelWidth || 85
      return Number(((this.$ELEMENT || {}).inputWidth || {})[this.elMode] || 230) + Number(labelWidth)
    },
    searchBtns() {
      let btns = [...this.btns]
      // 先提取导入按钮（如果存在）
      const importBtnIndex = btns.findIndex((obj) => obj.key === 'import')
      const importBtn = importBtnIndex !== -1 ? btns.splice(importBtnIndex, 1)[0] : null
      
      let queryBtn = {
        key: 'query',
        text: '$t[sui.form.query]',
        click: () => {
          this.$refs.form.valid((data) => {
            this.$emit('query', data)
          })
        },
        auth: this.$attrs['auth'] && this.$attrs['auth'].query,
        permissionId: this.permissions && this.permissions.query,
        'is-test': this.$attrs['is-test'] || false,
        'test-id': this.$attrs['test-id'] || null
      }
      let i = btns.findIndex((obj) => {
        return obj.key === 'query'
      })
      if (i === -1) {
        btns.unshift(queryBtn)
      } else {
        btns[i] = Object.assign(queryBtn, btns[i])
      }
      if (this.items.length > this.resetNum) {
        let resetBtn = {
          key: 'reset',
          type: 'primary',
          plain: true,
          text: '$t[sui.form.reset]',
          // icon: 'el-icon-refresh',
          click: () => {
            this.$refs.form.resetFields()
          },
          title: this.$t('sui.form.reset'),
          auth: this.auth && this.auth.reset,
          permissionId: this.permissions && this.permissions.reset,
          'is-test': this.$attrs['is-test'] || false,
          'test-id': this.$attrs['test-id'] || null
        }
        let i = btns.findIndex((obj) => {
          return obj.key === 'reset'
        })
        if (i === -1) {
          btns.push(resetBtn)
        } else {
          btns[i] = Object.assign(resetBtn, btns[i])
        }
        // 在重置按钮之后插入导入按钮
        if (importBtn) {
          const resetIndex = btns.findIndex((obj) => obj.key === 'reset')
          if (resetIndex !== -1) {
            btns.splice(resetIndex + 1, 0, importBtn)
          } else {
            btns.push(importBtn)
          }
        }
      } else if (importBtn) {
        // 如果没有重置按钮，直接添加导入按钮
        btns.push(importBtn)
      }

      if (this.showExport) {
        let exportBtn = {
          key: 'export',
          text: '$t[sui.form.export.export]',
          type: null,
          auth: this.permissions['export'],
          click: () => {
            this.$emit('export')
          }
        }
        btns.push(exportBtn)
      }

      // 展示更多按钮
      if (this.showMore) {
        let moreBtn = {
          key: 'more',
          text: this.showMoreBtnText,
          type: 'text',
          auth: this.permissions['moreFilter'],
          icon: this.hasHideItem ? 'el-icon-arrow-down' : 'el-icon-arrow-up',
          iconFloat: 'right',
          click: () => {
            this.toggleMoreCondition()
          }
        }
        btns.push(moreBtn)
      }
      return btns
    },
    formBtns() {
      if (this.btnsInline) {
        return this.searchBtns
      }
      return []
    },
    _selectItems() {
      const visibleRenderItems = this.renderVisibleItemsProps || []
      return this.items.filter(
        (it) =>
          it.mold &&
          it.mold.includes('select') &&
          (it.visible || (visibleRenderItems && visibleRenderItems.includes(it.prop)) || it.visible === undefined)
      )
    },
    _selectedItems() {
      if (this.hasHideItem) {
        return this._selectItems
          .filter((it) => !it.visible && !['', undefined, null].includes(this.model[it.prop]))
          .map((it) => ({ ...it, visible: true, useTagRef: true, labelHide: true, inputWidth: 'auto' }))
      }
      return []
    },
    _selectedFieldArr() {
      return [
        { tag: 'form-group', title: '已选标签', propArr: this._selectItems.filter((it) => it.mold.includes('select')).map((it) => it.prop) }
      ]
    }
  },
  watch: {
    moreValue(val, oldVal) {
      let add = difference(val, oldVal)
      let del = difference(oldVal, val)
      each(add, (prop) => {
        each(this.items, (item, idx) => {
          if (item.prop === prop) {
            item.visible = true
          }
        })
      })
      each(del, (prop) => {
        each(this.items, (item, idx) => {
          if (item.prop === prop) {
            item.visible = false
          }
        })
      })
    },
    // 异步items数据为异步获取时
    items() {
      this.renderItems()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.formEl = this.$refs.form
    })
  },
  methods: {
    renderItems() {
      let showNum = 0
      each(this.items, (item, idx) => {
        if (item.visible === undefined || item.visible) {
          if (showNum < this.hideNum) {
            this.$set(this.items[idx], 'visible', true)
          } else {
            if (this.hasHideItem) {
              this.$set(this.items[idx], 'visible', false)
            }
            if (this.renderVisibleItemsProps.indexOf(this.items[idx]['prop']) === -1) {
              this.renderVisibleItemsProps.push(this.items[idx]['prop'])
            }
          }
        }
        if (item.visible) {
          showNum++
        }
      })
    },
    toggleMoreCondition() {
      if (this.hasHideItem) {
        this.showMoreBtnText = '$t[sui.form.shouqi]'
        this.items.forEach((item, index) => {
          let isRenderVisibleItem = this.renderVisibleItemsProps.indexOf(item.prop) !== -1
          if (index > this.hideNum - 1 && isRenderVisibleItem) {
            this.$set(item, 'visible', true)
          }
        })
      } else {
        this.showMoreBtnText = '$t[sui.form.more]'
        let showNum = 0
        this.items.forEach((item, index) => {
          let isRenderVisibleItem = this.renderVisibleItemsProps.indexOf(item.prop) !== -1
          if (item.visible === undefined || isRenderVisibleItem) {
            if (showNum > this.hideNum - 1) {
              this.$set(item, 'visible', false)
            }
          }
          if (item.visible) {
            showNum++
          }
        })
      }
      this.hasHideItem = !this.hasHideItem
    },
    /** 隐藏字段 */
    hideFields(fields) {
      const fileds = this.formEl.getFields(fields)
      each(fileds, (item) => {
        const idx = this.renderVisibleItemsProps.indexOf(item)
        if (idx !== -1) {
          this.renderVisibleItemsProps.splice(idx, 1)
        }
      })
      this.formEl.hideFields(fields)
    },
    /** 显示字段 */
    showFields(fields) {
      this.formEl.showFields(fields)
    }
  }
}
</script>
<style lang="scss" scoped>
.sui-form-page {
  display: flex;
  flex-direction: row;
  transition: all ease-in-out 0.3s;
  > .form-left {
    flex: 1;
    margin-right: 16px;
  }
  > .form-right {
    // flex: 1;
    display: flex;
    align-items: flex-start;
    .more-btn {
      margin-right: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/other/SuiFormPage.vue